import mgmtSociety from "src/services/mgmtSocietyService";

export const FETCH_SOCIETY_INFO = "@society/info";
export const FETCH_SOCIETY_INFO_SUCCESS = "@society/info-success";
export const FETCH_SOCIETY_INFO_FAILURE = "@society/info-failure";

// Fetch Society List
export function fetchSocietyList() {
  return async (dispatch) => {
    try {
      dispatch({ type: FETCH_SOCIETY_INFO });

      const societyInfo = await mgmtSociety.societyList();

      dispatch({
        type: FETCH_SOCIETY_INFO_SUCCESS,
        payload: {
          societyInfo,
        },
      });
    } catch (error) {
      dispatch({ type: FETCH_SOCIETY_INFO_FAILURE });
      throw error;
    }
  };
}

// Add Society
export function addSociety(societyInfo) {
  return async (dispatch) => {
    try {
      await mgmtSociety.addSociety(societyInfo);
      dispatch(fetchSocietyList());
    } catch (error) {
      throw error;
    }
  };
}
// Edit Society
export function editSociety(societyInfo) {
  return async (dispatch) => {
    try {
      await mgmtSociety.editSociety(societyInfo);
      dispatch(fetchSocietyList());
    } catch (error) {
      throw error;
    }
  };
}

export function deleteSociety(societyId) {
  return async (dispatch) => {
    try {
      await mgmtSociety.deleteSociety(societyId);

      dispatch(fetchSocietyList());

    } catch (error) {
      throw error;
    }
  };
}